import type { trip as tripEn } from "../../en/webHints/trip";

// Nápovědy polí a záložek editoru zájezdu a hotelu (řez 10). Klíče volá registr nápověd
// (`apps/admin/src/lib/webHints/trip.ts`). Text „web“ jmenuje „<stránka> → <sekce>“ s podmínkou
// v závorce, bez předpony „Na webu:“; text „backoffice“ navazuje na „Nezobrazuje se na webu,
// slouží pro“. `fields.<pole>Hotel` je text varianty hotel, `tabs.<id>` účel záložky, jejíž
// obsah web nezobrazuje.
export const trip: typeof tripEn = {
  fields: {
    title:
      "Stránka zájezdu → hero (když není Titulek hero) a nadpis H1 (když není Nadpis stránky); karty ve výpisech a titulek pro vyhledávače; u hotelu Stránka hotelu → nadpis",
    slug: "Adresa stránky → /zajezd/<adresa>, u hotelu /hotel/<adresa>",
    destinationId: "Stránka destinace → Zájezdy; karty ve výpisech; výpis hotelů → filtr destinace",
    destinationTagIds:
      "Stránka štítkované destinace → Zájezdy (kombinovaný zájezd se ukáže i na stránkách dalších destinací); výpis hotelů → filtr destinace",
    guideId: "Stránka zájezdu → Váš průvodce; Stránka průvodce → jeho zájezdy",
    guideIdHotel:
      "Stránka průvodce → jeho zájezdy (stránka hotelu průvodce zájezdu neukazuje, ukazuje specialisty destinace)",
    guideVideoUrl: "Stránka zájezdu → Váš průvodce (video průvodce)",
    difficultyLevel:
      "Výpis zájezdů → rychlý náhled; Stránka zájezdu → Časté dotazy (výchozí otázka, když zájezd nemá vlastní otázky)",
    tripKind:
      "Stránka zájezdu → skladba stránky (zážitek: Co zažijete a Co vás čeká; jinak Itinerář)",
    fulfillmentMode:
      "Stránka zájezdu → Termíny (pevné termíny), nebo poptávka s kalendářem (na vyžádání); s typem Pobyt se zájezd ukazuje na stránce hotelu",
    tripType: "Stránka zájezdu → štítek typu pod popisem; výpis zájezdů → filtr typu",
    countryCodesText: "nabídku v PDF, vstupní úkoly objednávky a proměnné šablon (země zájezdu)",
    tripStyle: "Výpis zájezdů → filtr témat; menu → „Podle zážitku“",
    priceFrom: "Stránka zájezdu/hotelu → cena v rezervačním panelu; karty ve výpisech",
    priceIsFrom:
      "Stránka zájezdu → „od“ u ceny v rezervačním panelu a v poptávce; karty ve výpisech",
    priceOriginal:
      "Stránka zájezdu/hotelu → přeškrtnutá původní cena; karty ve výpisech → štítek SLEVA",
    durationHours:
      "Stránka zájezdu → délka zážitku v hero (jen zážitek); karty ve výpisech a rychlý náhled",
    durationDays:
      "Stránka zájezdu → délka v hero; karty ve výpisech; u hotelu Stránka hotelu → délka pobytu",
    groupSizeMin:
      "Stránka zájezdu → velikost skupiny a výchozí otázka v Častých dotazech; výpis zájezdů → rychlý náhled",
    groupSizeMax:
      "Stránka zájezdu → velikost skupiny a výchozí otázka v Častých dotazech; Termíny → kapacita nových termínů",
    groupSizeOpenEnded:
      "Stránka zájezdu → „od 1 osoby, podle domluvy“ místo horní hranice, i v Termínech; karty ve výpisech",
    defaultMeetingPoint:
      "místo srazu v portálu klienta a v aplikaci průvodce (termín ho může přepsat)",
    defaultMeetingTime:
      "čas srazu v portálu klienta a v aplikaci průvodce (termín ho může přepsat)",
    shortDescription:
      "Karty ve výpisech → perex; vyhledávače → popis stránky (když není Meta popis); u hotelu Stránka hotelu → perex pod nadpisem „Proč si vybrat tento hotel“ (jen s body „Proč si vybrat“, když není Nadpis stránky)",
    description: "Stránka zájezdu → popis pod nadpisem H1; u hotelu Stránka hotelu → popis",
    heroTitle: "Stránka zájezdu → text přes úvodní fotku (hero); prázdné = Název zájezdu",
    heading:
      "Stránka zájezdu → nadpis H1 nad popisem (prázdné = Název); u hotelu Stránka hotelu → perex pod nadpisem „Proč si vybrat tento hotel“ (jen s body „Proč si vybrat“)",
    metaTitle: "Vyhledávače → titulek stránky ve výsledcích hledání",
    metaDescription: "Vyhledávače → popis stránky ve výsledcích hledání",
    featuredImageId: "Stránka zájezdu/hotelu → hlavní obrázek; karty ve výpisech",
    isFeatured: "Úvodní stránka → doporučené zájezdy; karty ve výpisech → štítek NÁŠ TIP",
    isLastMinute:
      "Karty ve výpisech → štítek LAST MINUTE (když ho nevytlačí štítek s vyšší prioritou)",
    isForWomen: "Výpis zájezdů → filtr „Pro ženy“",
    hasCzechGuide:
      "Stránka zájezdu → štítek českého průvodce pod popisem; karty ve výpisech → štítek",
    tags: "Stránka zájezdu → štítky pod popisem",
    leadTimeHours:
      "Stránka zájezdu/hotelu → poptávka, nejbližší den, který kalendář nabídne (jen zájezd na vyžádání)",
    availableWeekdays:
      "Stránka zájezdu/hotelu → poptávka, dny, které kalendář nabízí (jen zájezd na vyžádání)",
    highlights: "Stránka zájezdu → Co zažijete (jen zážitek)",
    highlightsHotel: "Stránka hotelu → Proč si vybrat tento hotel (jen názvy bodů)",
    schedule: "Stránka zájezdu → Co vás čeká (program zážitku, jen zážitek)",
    hotelStars:
      "Stránka hotelu → hvězdičky u nadpisu; karta hotelu; výpis pobytů → filtr hvězdiček (jen u hotelu)",
    hotelMealPlans: "Stránka hotelu → strava a příplatky v poptávce; karta hotelu (jen u hotelu)",
    hotelDepartures: "Stránka hotelu → místa odletu v poptávce (jen u hotelu)",
    hotelFeatures:
      "Stránka hotelu → štítky zaměření pod nadpisem; výpis pobytů → filtr zaměření (jen u hotelu)",
    hotelRooms: "Stránka hotelu → pokoje a výběr pokoje v poptávce (jen u hotelu)",
    hotelCoordinatesText:
      "Stránka hotelu → Poloha hotelu (mapa); výpis zájezdů v pohledu Mapa → vlastní bod hotelu",
    included: "Stránka zájezdu/hotelu → Co je v ceně",
    excluded: "Stránka zájezdu/hotelu → Co není v ceně",
    note: "Stránka zájezdu/hotelu → poznámka pod Co je v ceně / Co není v ceně",
    optionalActivities:
      "Stránka hotelu → Fakultativní výlety (jen u hotelu); u ostatních zájezdů jen Nabídka v PDF → fakultativní výlety",
    itinerary:
      "Stránka zájezdu → Itinerář (ne u zážitku); vždy i Nabídka v PDF → program a aplikace průvodce",
    itineraryHotel: "program v nabídce v PDF a v aplikaci průvodce (stránka hotelu itinerář nečte)",
    galleryImageIds: "Stránka zájezdu/hotelu → Galerie",
    youtubeVideos: "Stránka zájezdu/hotelu → Videa",
    dates: "Stránka zájezdu → Termíny (jen zájezd s pevnými termíny)",
    components: "kusovník: návrh služeb a nákladů nových termínů a objednávek",
    faqs: "Stránka zájezdu/hotelu → Časté dotazy (zájezd bez vlastních otázek ukáže výchozí)",
    socialReels: "Stránka zájezdu/hotelu → Inspirujte se (krátká videa ze sociálních sítí)",
    mapImageId: "Stránka zájezdu → Mapa trasy; výpis zájezdů → pohled Trasy",
    mapImageIdHotel:
      "Výpis zájezdů → pohled Trasy (stránka hotelu ukazuje mapu ze souřadnic na záložce Hotel)",
    guideRecommendation:
      "Stránka zájezdu → Doporučení průvodce; u hotelu Stránka hotelu → Tip specialisty CK Go2",
    relatedItems:
      "Stránka zájezdu → Podobné zájezdy, které by se vám mohly líbit (ruční výběr první, doplní ho automatický; jen publikované zájezdy)",
    upgradeIds: "Stránka zájezdu → Prémiová vylepšení; objednávka → návrh položek",
    upgradeIdsHotel: "návrh položek objednávky (stránka hotelu prémiová vylepšení neukazuje)",
    relatedPageIds: "Stránka zájezdu → Více k tomuto zájezdu (jen publikované stránky)",
    status: "Stránka zájezdu/hotelu → celá stránka je vidět jen ve stavu Publikováno",
    tripInspirationLinks:
      "Stránka inspirace → Zájezdy, na kterých to zažijete (u vybraných inspirací); stránka zájezdu vazbu neukazuje",
    calculation:
      "kalkulaci nákladů a prodejní ceny a ceny v nabídce v PDF; „Použít na zájezd“ přepíše Cenu a ceny termínů",
  },
  tabs: {
    itineraryHotel: "nabídku v PDF a aplikaci průvodce (stránka hotelu itinerář nečte)",
    hotelTrip: "stránku hotelu, až bude zájezd Pobyt na vyžádání (stránka zájezdu tato pole nečte)",
    components: "kusovník: návrh služeb a nákladů nových termínů a objednávek",
    calculation: "kalkulaci nákladů a prodejní ceny a ceny v nabídce v PDF",
  },
};
